/**
 * @generated SignedSource<<29ca397ea375fb9aa3f083de570be210>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type contactUnarchiveContactMutation$variables = {
  ID: string;
};
export type contactUnarchiveContactMutation$data = {
  readonly unarchiveContact: {
    readonly ok: boolean;
  };
};
export type contactUnarchiveContactMutation = {
  variables: contactUnarchiveContactMutation$variables;
  response: contactUnarchiveContactMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "ID"
      }
    ],
    "concreteType": "UnarchiveContactPayload",
    "kind": "LinkedField",
    "name": "unarchiveContact",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contactUnarchiveContactMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contactUnarchiveContactMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b09ea7466f16c16bbf3fd5e43b21863b",
    "id": null,
    "metadata": {},
    "name": "contactUnarchiveContactMutation",
    "operationKind": "mutation",
    "text": "mutation contactUnarchiveContactMutation(\n  $ID: ID!\n) {\n  unarchiveContact(id: $ID) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "2c9142ceccc10562ae0f6c13c951dba6";

export default node;
